module.exports = __webpack_public_path__ + "img/message-start.191eb91e.svg";